import type EnType from '../en-US/api';

export default {
  'api.label.parameters': 'Requestパラメータ',
  'api.label.authorization': 'Authorization',
  'api.label.codeSample': 'リクエストコードサンプル',
  'api.label.authorization.inheritLabel': 'このAPIのAuthorization{type}を見る',
  'api.label.authorization.inheritLabel.folder': 'フォルダ<strong>{folderName}</strong>から継承',
  'api.label.authorization.inheritLabel.project': 'プロジェクトから継承',

  'api.label.authorization.description.apikey':
    '{position}にパラメータ<div class="locals-tag">{key}</div>を追加',
  'api.label.authorization.description.bearer':
    'Headerにパラメータ<div class="locals-tag">Authorization</div>を追加し、その値にはBearerの後にTokenを連結します',
  'api.label.authorization.description.basic':
    'Headerにパラメータ<div class="locals-tag">Authorization</div>を追加し、その値にはBasicの後にスペースと、Base64でエンコードされた<span class="ui-tag whitespace-normal break-all"><code>username:password</code></span>が連結されます',
  'api.label.authorization.description.digest':
    'Headerにパラメータ<div class="locals-tag">Authorization</div>を追加し、その値にはDigestの後にダイジェストハッシュ方式が連結されます',
  'api.label.authorization.description.hawk':
    'Headerにパラメータ<div class="locals-tag">Authorization</div>を追加し、その値にはHawkの後にダイジェストハッシュ方式が連結されます',
  'api.label.authorization.description.aws':
    '<div class="locals-tag">Authorization</div>と<div class="locals-tag">X-Amz-Date</div>をHeaderに追加',
  'api.label.authorization.description.aws.url':
    'URLに<div class="locals-tag">Authorization</div>情報と<div class="locals-tag">X-Amz-Date</div>を追加',
  'api.label.authorization.description.edgegrid':
    'Headerにパラメータ<div class="locals-tag">Authorization</div>を追加し、その値にはEG1-HMAC-SHA256の後にダイジェストハッシュ方式が連結されます',

  'api.label.responses': 'Response',
  'api.label.example': '例',
  'api.label.callbacks': 'Callbacks',
  'api.label.dataSchema': 'Schema',
  'api.auth.label.addAuthDataTo': 'Authデータを追加',
  'api.auth.label.addTo': '追加する場所',
  'api.auth.label.more': '詳細',
  'api.auth.label.moreTip':
    '以下はオプション設定です。空欄にすると、{appName} は自動的に値を生成します。',
  'api.auth.label.disableRetryRequest': '再試行禁止',
  'api.auth.label.disableRetryRequestTip':
    '{appName}はデフォルトで、受信した応答から値を抽出し、要求に追加してから再試行します。この機能を無効にしますか？',
  'api.parameterLabel.name': 'パラメータ名',
  'api.parameterLabel.value': 'パラメータ値',
  'api.parameterLabel.example': 'サンプル値',
  'api.parameterLabel.type': 'タイプ',
  'api.parameterLabel.noNeedToDefineTheBody': 'Bodyを定義する必要はありません',
  'api.parameterLabel.noNeedToDefineTheResponse': '応答を定義する必要はありません',
  'message.hasNoResponseBody': 'このResponseにはBodyがありません',
  'api.parameterLabel.file.disabled.tip':
    'Bodyがx-www-form-urlencodeの場合、fileタイプは利用できません。form-dataを使用してください',
  'api.status.designing': '設計中',
  'api.status.pending': '確定待ち',
  'api.status.developing': '開発中',
  'api.status.integrating': '統合中',
  'api.status.testing': 'テスト中',
  'api.status.tested': 'テスト完了',
  'api.status.released': 'リリース済み',
  'api.status.deprecated': '廃止予定',
  'api.status.obsolete': '廃止済み',
  'api.status.exception': '例外が発生',
  'api.automaticGenerated': '自動生成',
  'response.label.headers': 'Headers',
  'response.label.body': 'Body',
  'response.label.contentType': 'コンテンツ形式',
  'quickDebug.placeHolder.error': 'URLのフォーマットが不正です,{detail}',
  'quickDebug.placeHolder.detail': '完全なURLを入力してください。httpまたはhttpsで始めます。',
  'message.queryParameter': 'Queryパラメータ',
  'message.bodyParameter': 'Request Bodyパラメータ',
  'message.pathParameter': 'Pathパラメータ',
  'message.headerParameter': 'Headerパラメータ',
  'message.cookieParameter': 'Cookieパラメータ',
  'message.hasNoBodyParameter': 'このRequestにはBodyがありません',
  'api.auth.beginnerTips':
    'ここで追加したAuthorizationは、このディレクトリ内のすべてのRequestに適用され、個々のRequestで変更できます。',
  'api.auth.label.type': 'タイプ',
  'parameter.count.none': 'なし',
  'api.requestBody.binary.uploaded': 'アップロード済み',
  'api.requestBody.binary.notConfigured': '未設定',
  'api.request.auth.jwt.algorithm.label': 'アルゴリズム',
  'api.request.auth.jwt.secret.label': 'シークレット',
  'api.request.auth.jwt.isSecretBase64Encoded.label':
    'シークレットはBase64でエンコードされています',
  'api.request.auth.jwt.payload.label': 'ペイロード',
  'api.request.auth.jwt.headerPrefix.label': 'HTTP認証プレフィックス',
  'api.request.auth.jwt.header.label': 'カスタムJWTヘッダー',
  'api.request.auth.jwt.privateKey.label': 'プライベートキー',
  'api.request.auth.jwt.privateKey.button.label': 'ファイルを選択',
  'api.request.auth.jwt.queryParamKey.label': 'クエリパラメータ名',
  'api.request.auth.jwt.algorithm.placeholder': 'アルゴリズムを選択してください',
  'api.request.auth.jwt.secret.placeholder': 'シークレットを入力してください',
  'api.request.auth.jwt.payload.placeholder': 'JSONで作成する',
  'api.request.auth.jwt.headerPrefix.placeholder': 'HTTP認証プレフィックス',
  'api.request.auth.jwt.header.placeholder': 'JSONで作成する',
  'api.request.auth.jwt.privateKey.placeholder':
    '-----BEGIN PRIVATE KEY-----\nPKCS#8 PEM 形式のプライベートキー\n-----END PRIVATE KEY-----',
  'api.request.auth.jwt.queryParamKey.placeholder': 'クエリパラメータ名',
  'api.label.authorization.jwt.description1':
    '<div class="locals-tag">{name}</div>パラメータを{addTokenTo}に追加し、',
  'api.label.authorization.jwt.description2':
    'その値は、{headerPrefix}とその後に接続されたTokenです。',

  'api.label.authorization.oauth2.httpAuthorizationPrefix.label': 'HTTP認証の接頭辞',
  'api.label.authorization.oauth2.grantType.label': '許可種別',
  'api.parameterLabel.contentType': 'Content-Type',
  'modified.at.label': '更新日時',
  'built.with': 'Built with',
  slogan:
    'オールインワンAPIプラットフォーム：設計・デバッグ・モック作成・テスト実行・ドキュメント生成',
  'doc.anchor.title': '目次',
  'http.status.code.tooltip': 'HTTP Status Code',
  examples: 'Examples',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.title': '親のデフォルト認証値を使用',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.desc':
    '親フォルダに設定されたデフォルト認証値を使用',
  'api.auth.securitySchemeUseCase.valueAssignment.override.title': '手動設定',
  'api.auth.securitySchemeUseCase.valueAssignment.override.desc':
    '認証に必要な値を手動で設定します。',
  'api.auth.folderSecuritySchemeUseCase.defaultValue': 'デフォルト認証値',
  'api.auth.securitySchemeDefinition.more': '他の{count}件',
  'api.auth.securitySchemeDefinition.notToAuth': '認証しない',
  'api.auth.securitySchemeUseCase.valueIn': '{in}内',
  'api.label.sourceUrl': '原文リンク',
  'api.label.operationId': 'OperationId',
  'api.customAuth.error.message.title': 'エラー',
  'api.customAuth.redirect.title': 'リダイレクト中...',
  'api.action.mcp.modal.description':
    'AIコーディングを支援し、CursorのようなAIコーディングツールが現在のサイトのすべてのAPIドキュメントに直接アクセスできるようにします。',
  'api.action.mcp.modal.editor.other': 'その他',
  'api.action.mcp.modal.cursor.copy': '一括追加',
  'api.action.mcp.modal.cursor.or': 'または',
  'api.action.mcp.modal.cursor.manualCopy': '手動設定',
  'api.action.mcp.modal.cursor.button.text': 'Cursorに追加',
  'api.action.mcp.modal.cursor.version': 'Cursorバージョン1.0以上のみ対応',
  'api.action.mcp.modal.commandTip':
    '注意：Node.js環境がインストールされている必要があります（バージョン >= 18）',
  'api.action.mcp.modal.footer.question': 'JSONをコピーした後、MCPの使い方は？',
  'api.action.mcp.modal.footer.help': 'ヘルプを見る',
  'api.action.mcp.modal.command.doc': 'APIドキュメント',
} satisfies typeof EnType;
